import { Directive, ElementRef, HostListener, AfterViewInit  } from "@angular/core";

@Directive({
    standalone: false,
    selector: "[appTextareaAutosize]",
})
export class TextareaAutosizeDirective implements AfterViewInit {
    appTextareaAutosize: HTMLTextAreaElement;

    @HostListener("input") onInput(): void {
        this.setHeight();
    }

    constructor(private elementRef: ElementRef<HTMLTextAreaElement>) {
        this.appTextareaAutosize = this.elementRef.nativeElement;
    }

    ngAfterViewInit() {
        setTimeout(() => this.setHeight(), 250);
      }

    private setHeight(): void {
        this.appTextareaAutosize!.style.height = "auto";
        this.appTextareaAutosize!.style.height =
            this.appTextareaAutosize!.scrollHeight + "px";
    }
}
